<template>
  <div id="profile">
    <div class="container px-3 px-lg-0">
      <h1>Profile</h1>
      <Tabs :tabs="tabs" v-model="tab" />
      <div class="tab-pane container px-0 my-2 active">
        <ContentLoader v-if="!currentTabComponent.data.length" />
        <component
          v-bind:is="currentTabComponent.component"
          :data="currentTabComponent.data"
          class="tab"
          v-else
        ></component>
      </div>
    </div>
    
  </div>
</template>

<script>
import { getBookmarks } from "@/api/services/bookmark";
import { getContactedSuppliers } from "@/api/services/supplier";
import Tabs from '@/components/Tabs';
import BookmarkedProducts from '@/components/buyer/BookmarkedProducts';
import ContactedSuppliers from '@/components/buyer/ContactedSuppliers';
export default {
  components: {
    Tabs,
    BookmarkedProducts,
    ContactedSuppliers
  },
  data() {
    return {
        bookmarks: [],
        tab: 0,
        products: []
    }
  },
  computed: {
    tabs() {
      return [
        {
          title: 'Bookmarked Products',
          component: BookmarkedProducts,
          data: this.bookmarks
        },
        {
          title: 'Contacted Suppliers',
          component: ContactedSuppliers,
          data: this.products
        }
      ];
    },
    currentTabComponent() {
      return this.tabs[this.tab];
    },
  },
  mounted() {
    this.getBookmarks()
    this.getProducts()
    this.tab = JSON.parse(localStorage.getItem('profile-active-tab') || 0)
  },
  methods: {
    async getBookmarks() {
      let { data } = await getBookmarks(this.$user.id)
      this.bookmarks = data
    },
    async getProducts() {
      let { data } = await getContactedSuppliers()
      this.products = data
      console.log('from profile');
    }
  }
}
</script>